import { useState } from "react";
import { useEffect } from "react";
import { SEA_FILTERED_CARDS_QUERY_CACHE_KEY, SEA_QUERY_CACHE_KEY } from "entities/SeaSavedCard";

type UseSeaQueryKeyProps = {
  isCurrentViewFilteredCards: boolean;
  isCurrentViewMain: boolean;
};

type UseSeaQueryKeyReturnType = {
  queryKey: string;
};

export const useSeaQueryKey = ({
  isCurrentViewFilteredCards,
  isCurrentViewMain,
}: UseSeaQueryKeyProps): UseSeaQueryKeyReturnType => {
  const [queryKey, setQueryKey] = useState<string>(SEA_FILTERED_CARDS_QUERY_CACHE_KEY);

  useEffect(() => {
    if (isCurrentViewFilteredCards) {
      setQueryKey(SEA_FILTERED_CARDS_QUERY_CACHE_KEY);
    }
    if (isCurrentViewMain) {
      setQueryKey(SEA_QUERY_CACHE_KEY);
    }
  }, [isCurrentViewFilteredCards, isCurrentViewMain]);

  return { queryKey };
};
